import React, { FC } from 'react'
import { Strip } from '@moonpig/launchpad-components'
import { useProductContext } from '../../../contexts/product'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'

export const OfferBannerModule: FC<ProductModule> = props => {
  const [
    {
      departmentInfo: { promotionBanner },
    },
  ] = useProductContext()

  return promotionBanner ? (
    <ProductModuleSection {...props}>
      <Strip data-testid="offer-banner">{promotionBanner}</Strip>
    </ProductModuleSection>
  ) : null
}
